module.exports = __webpack_public_path__ + "static/media/title_bitwitches_bleed.629d0ea2.svg";